import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Container, FormControlLabel, Link, Paper, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../app/store';
import Header from '../components/Header';
import Loading from '../components/Loading';
import { getPrivacyPolicyUrl, getSelectBoxes, putData } from '../services/ApiService';
import { GrpUnitGetData } from '../services/dto/grpCmmUnitDto';
import { RsvAccountPutRequest } from '../services/dto/rsvAccountDto';

const SCREEN = 'confirm';

interface SelectBox {
  grpId?: number;
  id: number;
  name: string;
}

const Confirm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const input = useSelector((state: RootState) => state.input);
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('');
  const [checked, setChecked] = useState(false);

  const [countries, setCountries] = useState<SelectBox[]>([]);
  const [prefectures, setPrefectures] = useState<SelectBox[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // selectboxデータ取得
        const {countries, provices} = await getSelectBoxes();
        if (countries !== undefined) {
          setCountries(countries);
        } else {
          console.log("Failed to fetch countries");
        }
        if (provices !== undefined) {
          setPrefectures(provices);
        } else {
          console.log("Failed to fetch countries");
        }

        // プライバシーポリシーURLセット
        const res = await getPrivacyPolicyUrl();
        const data: GrpUnitGetData = res.data;
        setPrivacyPolicyUrl(data.privacyPolicyUrl);
        axios.defaults.headers.common['X-Unit-Cd'] = data.unitCd;
      } catch (error) {
        console.error('Error fetching unit data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleBack = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate("/signature");
  };

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setLoading(true);
    console.log(input)
    const request: RsvAccountPutRequest = {
      ...input,
    };
    console.log(request)

    try {
      const res = await putData(request);
      setLoading(false);
      if (res.data) {
        navigate("/complete");
      }
    } catch (error) {
      console.error('error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
        <Header title={t(`${SCREEN}.title`)} />
        <Loading open={loading} />
        <Box mt={2}>
          {input.guests.map((guest, index) => (
            <div key={guest.id}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {t(`confirm.guest`)}{index + 1}
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{t(`confirm.altNm`)}: {guest.altNm}</Typography>
                  <Typography>{t(`confirm.firstNm`)}: {guest.firstNm}</Typography>
                  <Typography>{t(`confirm.contact`)}: {guest.contact}</Typography>
                  <Typography>{t(`confirm.rcountryId`)}: {countries.find(country => country.id === guest.rcountryId)?.name}</Typography>
                  <Typography>{t(`confirm.country`)}: {countries.find(country => country.id === guest.countryId)?.name}</Typography>
                  <Typography>{t(`confirm.postNo`)}: {guest.postNo}</Typography>
                  {prefectures.some(pref => pref.grpId === guest.countryId) &&
                    <Typography>{t(`confirm.provinceId`)}: {prefectures.find(pref => pref.id === guest.provinceId)?.name}</Typography>
                  }
                  <Typography>{t(`confirm.address1`)}: {guest.address1}</Typography>
                  <Typography>{t(`confirm.email`)}: {guest.email}</Typography>
                  {guest.signature &&
                    <img src={guest.signature} alt="Signature Preview" style={{ border: '1px solid #000', maxWidth: '100%' }} />
                  }
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
          <Typography>{t(`confirm.receipt`)}: {input.receipt}</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChange}
                name="privacyPolicy"
                color="primary"
              />
            }
            label={
              <span>
                {t(`confirm.pre`)}
                <Link href={privacyPolicyUrl} target="_blank" rel="noopener">
                  {t(`confirm.privacy`)}
                </Link>
                {t(`confirm.suffix`)}
              </span>
            }
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={handleBack}
              style={{ marginTop: '1rem' }}
            >
              {t(`${SCREEN}.back`)}
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!checked}
              fullWidth
              onClick={handleSubmit}
              style={{ marginTop: '1rem' }}
            >
              {t(`${SCREEN}.send`)}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}
export default Confirm;
